export default __webpack_public_path__ + "static/media/portfolio-149.80923155.jpg";